import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AISearchSearchResult } from './types';

export interface AIAssistantState {
  isDialogOpen: boolean;
  lastSearch: AISearchSearchResult | null;
}

const initialState: AIAssistantState = {
  isDialogOpen: false,
  lastSearch: null,
};

const aiAssistantSlice = createSlice({
  name: 'aiAssistant',
  initialState,
  reducers: {
    setAIAssistantDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isDialogOpen = action.payload;
    },
    openAIAssistant: (state) => {
      state.isDialogOpen = true;
    },
    closeAIAssistant: (state) => {
      state.isDialogOpen = false;
    },
    clearAIAssistantConversation: (state) => {
      state.lastSearch = null;
    },
    setAILastSearch: (state, action: PayloadAction<AISearchSearchResult | null>) => {
      state.lastSearch = action.payload;
    },
  },
});

export const {
  setAIAssistantDialogOpen,
  openAIAssistant,
  closeAIAssistant,
  clearAIAssistantConversation,
  setAILastSearch,
} = aiAssistantSlice.actions;

export default aiAssistantSlice.reducer;
